import { createElement, type ComponentType } from 'react'

import type { InventoryFilters } from '@/lib/api/client/inventory'
import type { InventoryListItem } from '@/lib/api/schemas/inventory.schema'
import { PublishToStorefrontDialog } from '@/components/storefronts/PublishToStorefrontDialog'
import { REPRICE_SELECTION_ACTION } from '@/lib/views/actions/reprice'
import { YMARKET_RECONCILE_SELECTION_ACTION } from '@/lib/views/actions/ymarket-reconcile'
import { productStatusOf } from '@/lib/warehouse/projection'
import type { ActionKey, ViewGrain } from '@/lib/views/presets'

export type SelectionScope<Filters> =
  | { kind: 'ids'; ids: readonly string[] }
  | { kind: 'filter'; filter: Filters; expectedTotal: number }

export type SelectionEligibility =
  | { ok: true }
  | { ok: false; reason: string }

export interface SelectionAction<
  Grain extends ViewGrain = ViewGrain,
  Row = never,
  Filters = never,
  Key extends string = ActionKey,
> {
  key: Key
  grain: Grain
  label: string
  eligible: (row: Row) => SelectionEligibility
  Dialog: ComponentType<{
    selection: SelectionScope<Filters>
    /** The selected rows the page has seen; a selection may reach pieces it never loaded. */
    rows?: readonly Row[]
    onDone: () => void
  }>
}

export type InventorySelectionAction = SelectionAction<'inventory', InventoryListItem, InventoryFilters, ActionKey>

export const PUBLISH_SELECTION_ACTION: SelectionAction<'inventory', InventoryListItem, InventoryFilters, 'publish'> = {
  key: 'publish',
  grain: 'inventory',
  label: 'Опубликовать на…',
  eligible: (row) => productStatusOf(row).status === 'in_stock'
    ? { ok: true }
    : { ok: false, reason: 'Не на складе — заливать нельзя' },
  Dialog: ({ selection, onDone }) => createElement(PublishToStorefrontDialog, { selection, onDone }),
}

export const SELECTION_ACTION_REGISTRY: readonly InventorySelectionAction[] = [PUBLISH_SELECTION_ACTION, REPRICE_SELECTION_ACTION, YMARKET_RECONCILE_SELECTION_ACTION]
